<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 215.234"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M47.617 169.241c-0.826,15.06 0.756,28.418 4.745,40.075 -11.274,-3.71 -27.485,-18.407 -29.001,-32.756 9.338,0.502 17.424,-1.937 24.256,-7.319z"
        />
        <path
            class="fil1 str1"
            d="M47.617 169.241c-6.832,5.382 -14.918,7.821 -24.256,7.319 -0.136,-1.289 -0.154,-2.574 -0.039,-3.849 -0.504,-8.564 1.616,-16.816 5.195,-23.75 0.572,-1.109 1.183,-2.184 1.825,-3.221 6.605,5.28 12.856,8.248 18.751,8.905 -0.726,5.031 -1.219,9.897 -1.476,14.596z"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
        />
        <path
            class="fil1 str1"
            d="M43.079 116.63c3.765,-31.324 5.159,-43.402 -0.884,-87.524 2.623,-9.923 10.183,46.913 5.653,89.697 -1.212,-0.649 -2.536,-1.104 -4.769,-2.173z"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
        />
        <path
            class="fil1 str1"
            d="M63.195 169.644c2.187,14.297 3.213,26.892 3.078,37.786 -3.1,1.9 -6.299,2.838 -9.288,2.774 -1.39,-0.03 -2.952,-0.339 -4.623,-0.888 -3.989,-11.657 -5.571,-25.015 -4.745,-40.075 0.257,-4.699 0.75,-9.565 1.476,-14.596 3.878,0.432 7.601,-0.136 11.172,-1.703 1.138,5.804 2.114,11.371 2.93,16.702z"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
        />
        <path
            class="fil1 str1"
            d="M49.093 154.645c-5.895,-0.657 -12.146,-3.625 -18.751,-8.905 5.874,-9.484 14.471,-15.801 22.155,-15.801 7.215,0 15.162,4.23 21.154,11.502 -4.193,5.59 -8.654,9.424 -13.386,11.501 -3.571,1.567 -7.294,2.135 -11.172,1.703z"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
        />
        <path
            class="fil1 str1"
            d="M63.195 169.644c-0.816,-5.331 -1.792,-10.898 -2.93,-16.702 4.732,-2.077 9.193,-5.911 13.386,-11.501 2.613,3.172 4.854,6.923 6.5,11.154 0.272,0.765 0.548,1.544 0.832,2.336 1.291,3.988 2.06,8.354 2.142,13.028 -8.104,-2.067 -14.747,-1.506 -19.93,1.685z"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
        />
        <path
            class="fil1 str1"
            d="M63.195 169.644c5.183,-3.191 11.826,-3.752 19.93,-1.685 0.196,20.501 -7.911,33.989 -16.852,39.471 0.135,-10.894 -0.891,-23.489 -3.078,-37.786z"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M83.125 167.959c-0.396,-22.59 -16.848,-38.02 -30.628,-38.02 -13.78,0 -30.496,20.315 -29.175,42.772 -1.585,17.574 22.051,37.241 33.663,37.493 11.613,0.251 26.404,-14.639 26.14,-42.245zm-2.142 -13.028c-10.937,-30.564 -12.276,-40.675 -14.609,-62.812 -2.332,-22.137 -3.26,-64.001 -14.257,-78.944 -15.535,-21.111 -24.078,-6.529 -21.386,40.396m-2.214 95.39c1.106,-34.018 1.844,-65.815 2.214,-95.39"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
